import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { StatementItem, type StatementItemConstructor } from './StatementItem'

export const StatementItemConstructorFactory =
  Factory.Sync.makeFactory<StatementItemConstructor>({
    id: Factory.each(() => faker.random.number()),
    creditcardId: Factory.each(() => faker.random.number()),
    date: '2024-01-15',
    description: Factory.each(() => faker.commerce.productName()),
    amount: Factory.each(() => faker.finance.amount()),
    duplicateOf: null,
    matchId: null,
  })

export const StatementItemFactory = EntityFactory(
  StatementItem,
  StatementItemConstructorFactory
)
